// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d1cd7b {
  margin: 0;
  padding: 0;
}
.a09145 {
  line-height: 1.2307692308;
  font-size: 0.8125rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.a09145 + .a09145:not(.f87d7a) {
  margin-bottom: 8px;
}
.b7f566 {
  line-height: 1.45;
  font-size: 0.688rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.ca7db2 {
  line-height: 1.2307692308;
  font-size: 0.8125rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.b475fe {
  line-height: 1.25;
  font-size: 1rem;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.b8be2d {
  white-space: pre-wrap;
}
.cef25a {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}
.f87d7a.f87d7a {
  margin: 0;
}
.ac6dd0 {
  text-align: center;
}
.a1ed12 {
  text-align: left;
}
.f251c3 {
  text-align: right;
}
.cb0c50 {
  width: 100%;
}
.e07e0d {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.f78938 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.e9dcd1 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.a526ab {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.fe1318 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

@supports (-webkit-line-clamp: 2) {
  .f78938 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 3) {
  .e9dcd1 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 4) {
  .a526ab {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 5) {
  .fe1318 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Typography/texts/BaseText/BaseText.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF","sourcesContent":[".d1cd7b {\n  margin: 0;\n  padding: 0;\n}\n.a09145 {\n  line-height: 1.2307692308;\n  font-size: 0.8125rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.a09145 + .a09145:not(.f87d7a) {\n  margin-bottom: 8px;\n}\n.b7f566 {\n  line-height: 1.45;\n  font-size: 0.688rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.ca7db2 {\n  line-height: 1.2307692308;\n  font-size: 0.8125rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.b475fe {\n  line-height: 1.25;\n  font-size: 1rem;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.b8be2d {\n  white-space: pre-wrap;\n}\n.cef25a {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n}\n.f87d7a.f87d7a {\n  margin: 0;\n}\n.ac6dd0 {\n  text-align: center;\n}\n.a1ed12 {\n  text-align: left;\n}\n.f251c3 {\n  text-align: right;\n}\n.cb0c50 {\n  width: 100%;\n}\n.e07e0d {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.f78938 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.e9dcd1 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.a526ab {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.fe1318 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n@supports (-webkit-line-clamp: 2) {\n  .f78938 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 3) {\n  .e9dcd1 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 4) {\n  .a526ab {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 4;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 5) {\n  .fe1318 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 5;\n      -webkit-box-orient: vertical;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
